// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about-button[data-v-a2c286fe]{min-width:14.5rem}.link[data-v-a2c286fe]{-webkit-text-decoration:underline;text-decoration:underline}.paragraph[data-v-a2c286fe]{color:#000;line-height:1.467rem}.hexagon[data-v-a2c286fe]{position:absolute;right:150px;top:120px;width:180px}@media(min-width:768px)and (max-width:996px){.image-col[data-v-a2c286fe]{display:flex;flex-direction:column;justify-content:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
